module.exports = __webpack_public_path__ + "img/1.12c4c25c.jpg";